module.exports = __webpack_public_path__ + "img/fastvaluedeal-reviews.d63a9f25.png";